import { amIAnObviousBot } from '../global';
import { browserBotClassifier } from './browser_bot_classifier';

class PageviewTracker {
  constructor() {
    this.fired = false;
    this.timeoutId = null;
    this.triggerMethod = 'immediate';
    this.triggerTimeoutSeconds = 0;
    this.interactionSummary = null;

    if (typeof(Storage) !== "undefined") {
      this.firstVisitTimestamp = localStorage.getItem("firstVisitTimestamp");
      this.previousVisitTimestamp = localStorage.getItem("previousVisitTimestamp");
    }
  }

  themeColor() {
    return $('html').attr('data-theme');
  }

  waitForUserInteractionOrTimeout(seconds, callback) {
    console.debug(`Waiting for user interaction or ${seconds} seconds timeout or user interaction...`);
    this.fired = false;
    this.triggerTimeoutSeconds = seconds;
    const startTime = Date.now();
    this.timeoutId = setTimeout(() => {
      if (!this.fired) {
        this.fired = true;
        this.triggerMethod = 'timeout';
        removeEventListeners();
        console.debug("Timeout reached, proceeding to call the callback.");
        callback();
      }
    }, seconds * 1000);

    let trackingInteractions = false;
    let interactionTrackingTimeout = null;
    const interactionCounts = {};

    const handleInteraction = (event) => {
      if (!trackingInteractions) {
        trackingInteractions = true;
        this.triggerMethod = 'user_interaction';
        console.debug("User interaction detected, tracking for 1 second...");
        const delay = (Date.now() - startTime) / 1000;

        interactionTrackingTimeout = setTimeout(() => {
          if (!this.fired) {
            this.fired = true;
            clearTimeout(this.timeoutId);
            removeEventListeners();

            this.interactionSummary = {
              event_types: Object.keys(interactionCounts),
              event_counts: interactionCounts,
              total_events: Object.values(interactionCounts).reduce((a, b) => a + b, 0),
              delay_seconds: parseFloat(delay.toFixed(3))
            };
            console.debug("Interaction tracking complete:", this.interactionSummary);
            callback();
          }
        }, Math.min(1, seconds * 0.8) * 1000);
      }

      if (trackingInteractions) {
        interactionCounts[event.type] = (interactionCounts[event.type] || 0) + 1;
      }
    };

    const events = ['mousedown', 'mousemove', 'scroll', 'keydown', 'touchstart'];

    const removeEventListeners = () => {
      events.forEach(event => {
        document.removeEventListener(event, handleInteraction);
      });
      if (interactionTrackingTimeout) {
        clearTimeout(interactionTrackingTimeout);
      }
    };

    events.forEach(event => {
      document.addEventListener(event, handleInteraction);
    });
  }

  browserNameAndVersion() {
    const userAgent = navigator.userAgent;
    let browserName = "Unknown";
    let fullVersion = "Unknown";

    if (userAgent.indexOf("Chrome") > -1) {
      browserName = "Chrome";
      fullVersion = userAgent.substring(userAgent.indexOf("Chrome") + 7);
    } else if (userAgent.indexOf("Firefox") > -1) {
      browserName = "Firefox";
      fullVersion = userAgent.substring(userAgent.indexOf("Firefox") + 8);
    } else if (userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") === -1) {
      browserName = "Safari";
      fullVersion = userAgent.substring(userAgent.indexOf("Safari") + 7);
    } else if (userAgent.indexOf("Edg/") > -1) {
      browserName = "Edge";
      fullVersion = userAgent.substring(userAgent.indexOf("Edg/") + 4);
    } else {
      const nameOffset = userAgent.lastIndexOf(' ') + 1;
      const verOffset = userAgent.lastIndexOf('/');
      if (nameOffset < verOffset) {
        browserName = userAgent.substring(nameOffset, verOffset);
        fullVersion = userAgent.substring(verOffset + 1);
      }
    }

    return { browserName, fullVersion };
  }

  isOldBrowser() {
    const { browserName, fullVersion } = this.browserNameAndVersion();
    if (browserName === "Chrome") {
      const majorVersion = parseInt(fullVersion.split('.')[0]);
      if (majorVersion <= 148) {
        return true;
      }
    } else if (browserName === "Firefox") {
      const majorVersion = parseInt(fullVersion.split('.')[0]);
      if (majorVersion <= 151) {
        return true;
      }
    }
    return false;
  }

  referrer() {
    return document.referrer || null;
  }

  postPageview(onComplete) {
    var meta_csrf = $('meta[name=csrf-token]');
    if (meta_csrf.length == 0) {
      return;
    }

    const ignoreMe = localStorage.getItem("ignoreMe");
    if (ignoreMe === 'true') {
      return;
    }

    var advertiser = $(".sidebar-square-image").data("advertiser");
    var ad_campaign_id = $(".sidebar-square-image").data("ad-campaign-id");
    var sidebar_ad_space = $("div.sidebar-ad-space").length > 0;

    var stats = {
      advertiser: advertiser,
      ad_campaign_id: ad_campaign_id,
      num_vpsb_ad_unit: $('#vpsb-square-image').length,
      num_codefund_ad_unit: 0,
      sidebar_ad_space: sidebar_ad_space,
      theme_color: this.themeColor(),
      trigger_method: this.triggerMethod,
      trigger_timeout_seconds: this.triggerTimeoutSeconds,
      referrer: this.referrer(),
      current_page_url: window.location.href,
      browser_bot_classification: browserBotClassifier.evaluate(),
    };

    if (this.interactionSummary) {
      stats.interaction_summary = this.interactionSummary;
    }

    if (this.previousVisitTimestamp) {
      stats.previous_visit_timestamp_ms = this.previousVisitTimestamp;
    }
    if (this.firstVisitTimestamp) {
      stats.first_visit_timestamp_ms = this.firstVisitTimestamp;
    }

    var csrfToken = meta_csrf.attr('content');
    $.ajax({ method: "POST",
           url: `/api/pageviews`,
           data: stats,
           dataType: 'json',
           headers: { "X-CSRF-Token": csrfToken },
           success: (response) => onComplete(response.bot),
    });
  }

  postWithCaution(onComplete) {
    if (amIAnObviousBot()) {
      console.debug("Detected as bot via amIAnObviousBot, skipping pageview.");
      return;
    }

    const isFirstDirectVisit = !this.firstVisitTimestamp && !this.referrer();

    if (this.isOldBrowser() || isFirstDirectVisit) {
      this.waitForUserInteractionOrTimeout(6, () => this.postPageview(onComplete));
    } else {
      this.postPageview(onComplete);
    }
  }
}

export function postPageviewWithCaution(onComplete) {
  const tracker = new PageviewTracker();
  tracker.postWithCaution(onComplete);
}
